exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-ec412b4a] .el-tabs{height:100%}[data-v-ec412b4a] .el-tabs .el-tabs__content{height:calc(100% - 34px)}[data-v-ec412b4a] .el-tabs .el-tabs__content .el-tab-pane{height:100%}", ""]);

// exports
